<template>
    <b-container class="p-0">
        <div class="rw-arrange-letters">
            <div class="question-example mt-4">
                <p class="text-start section-title mb-0"><strong>Example</strong></p>
                <div class="example__block border p-2 rounded">
                    <!-- <img class="mw-100" :src="exampleImage" alt=""> -->
                    <b-row class="question-box">
                        <b-col cols="4" class="d-flex align-items-center" v-if="qdata.image">
                            <div class="question-item__image">
                                <img class="mw-100" :src="exampleImage" alt="">
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <div class="example h-100 d-flex align-items-center justify-content-center">
                                <p>C</p>
                                <p>A</p>
                                <p>R</p>
                            </div>
                        </b-col>
                        <b-col cols="4" v-if="qdata.image2">
                            <div class="question-item__image">
                                <img class="mw-100" :src="exampleImage2" alt="">
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="question-content mt-4">
                <p class="text-start section-title mb-0"><strong>Question</strong></p>
                <b-row class="question-box">
                    <b-col cols="4" v-if="qdata.image" class="d-flex align-items-center">
                        <div class="question-item__image">
                            <img class="mw-100" :src="imageSrc(qdata.image.data.src)" alt="">
                        </div>
                    </b-col>
                    <b-col cols="4">
                        <div class="h-100 d-flex align-items-center justify-content-center">
                            <OtpInput v-model="answer" :text="qdata.label2.data.value"/>
                        </div>
                    </b-col>
                    <b-col cols="4" v-if="qdata.image2">
                        <div class="question-item__image">
                            <img class="mw-100" :src="imageSrc(qdata.image2.data.src)" alt="">
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-container>
</template>

<script>

import OtpInput from './components/OtpInput.vue'

import {
    BRow,
    BCol,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'rw_arrange_letters',
    components: {
        BRow,
        BCol,
        BContainer,
        OtpInput
    },
    props: {
        qdata: Object
    },
    data() {
        return {
            checkDarkIcon: require('@/assets/icons/check-dark.png'),
            imageDefault: require('@/assets/img-default.jpg'),
            exampleImage: require('@/assets/kidbox-example/rw_arrange_letters.png'),
            exampleImage2: require('@/assets/kidbox-example/rw_arrange_letters2.png'),
            answer: null
        }
    },
    methods: {
        changeValue(value) {
            this.answer = value
            this.$emit('input', value)
        },
        imageSrc (src) {
            if (src && src !== '') { return src }
            return this.imageDefault
        }
    },
    watch: {
        answer : {
            handler(value) {
                this.$emit('input', {
                    answers: value,
                })
            },
            deep: true
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
.checkbox {
    border: 2px solid;
    padding: 2px;
    margin: 10px;
    border-radius: 5px;
    cursor: pointer;
    width: 45px;
    height: 45px;
}

.example p {
    display: inline-block;
    width: 45px;
    height: 45px;
    text-align: center;
    margin: 2px;
    border: 1px solid #000;
    border-radius: 4px;
    font-family: 'iCiel Crocante';
    font-size: 2rem;
}

.question-box {
    align-items: center;
}
</style>